import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/AdminMasterEquipment.css';

const AdminMasterEquipment = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="admin-master-equipment">
      <div className="admin-page-header">
        <h1>Master Equipment</h1>
        <p>Manage equipment categories and attributes</p>
      </div>

      <div className="master-equipment-options">
        <div className="dropdown-container">
          <button className="dropdown-btn" onClick={toggleDropdown}>
            Select Option
            <i className={`dropdown-icon ${isDropdownOpen ? 'open' : ''}`}>▼</i>
          </button>
          {isDropdownOpen && (
            <div className="dropdown-menu">
              <Link to="/admin/master-equipment/category">Category</Link>
              <Link to="/admin/master-equipment/attribute">Attribute</Link>
            </div>
          )}
        </div>

        <div className="master-equipment-content">
          <div className="welcome-section">
            <h2>Welcome to Master Equipment Management</h2>
            <p>Please select an option from the dropdown to manage Categories or Attributes.</p>
            <div className="quick-access">
              <Link to="/admin/master-equipment/category" className="quick-link">
                <div className="quick-link-icon">📋</div>
                <div className="quick-link-text">
                  <h3>Categories</h3>
                  <p>Manage equipment categories and classifications</p>
                </div>
              </Link>
              <Link to="/admin/master-equipment/attribute" className="quick-link">
                <div className="quick-link-icon">🏷️</div>
                <div className="quick-link-text">
                  <h3>Attributes</h3>
                  <p>Manage equipment attributes and specifications</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminMasterEquipment;